import React from 'react';


const Loader = ({ size = '50px', color = '#da0383' }) => {
    return (
        <div className="flex justify-center items-center">
            <svg
                viewBox="0 0 50 50"
                style={{ width: size, height: size }}
            >
                <path
                    d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
                    transform="rotate(241.969 25 25)"
                    style={{ fill: '#da0383', stroke: color, strokeWidth: 2 }}
                >
                    <animateTransform
                        attributeType="xml"
                        attributeName="transform"
                        type="rotate"
                        from="0 25 25"
                        to="360 25 25"
                        dur="0.8s"
                        repeatCount="indefinite"
                    />
                </path>
            </svg>
        </div>
    );
};



export default Loader;